import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isOnTrip = location.pathname.startsWith('/trips/');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-brand" onClick={() => navigate('/')}>
          <span className="navbar-icon">✈️</span>
          <span className="navbar-logo">MyTrip</span>
        </div>

        <div className="navbar-right">
          {isOnTrip && (
            <button className="btn-back" onClick={() => navigate('/')}>
              ← My Trips
            </button>
          )}
          <div className="navbar-user">
            <div className="navbar-avatar">
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <span className="navbar-name">{user?.name}</span>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            Sign out
          </button>
        </div>
      </div>
    </nav>
  );
}
